import { useMemo } from 'react';
import { useTranslations } from '@core/js/hooks/i18n';
import { useHeadTags } from '@theme/js/hooks/swiss/useHeadTags';

export const useReferFriendAndRegisterMetaTags = (ogUrl = '') => {
    const translate = useTranslations();
    const isRegisterPage = window.location.href.includes('/register');
    const isReferPage = window.location.href.includes('/refer-a-friend') || window.location.href.includes('/bring-a-friend');
    const shouldAddMetatags = isRegisterPage || isReferPage;

    const translatedOGTitle = isReferPage ? translate('playtech.mobile.referafriend.title') : translate('playtech.mobile.registration.ogTitle');
    const translatedOGDescription = isReferPage ? translate('playtech.mobile.referafriend.ogDescription') : translate('playtech.mobile.registration.ogDescription');

    const tags = useMemo(() => shouldAddMetatags ? [
        { property: 'og:description', content: translatedOGDescription },
        { property: 'og:title', content: translatedOGTitle },
        ...ogUrl ? [{ property: 'og:url', content: ogUrl }] : []
    ] : [{
        // TODO: This is harcode and should be removed once we will have SSR
            property: 'og:title', content: 'Swiss Casinos'
        }],
        [
            shouldAddMetatags,
            ogUrl,
            translatedOGDescription,
            translatedOGTitle
        ]);

    useHeadTags(tags);
};
